import { Injectable } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {JqueryRunnerService} from "./jquery-runner";

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private jqueryRunner: JqueryRunnerService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler):   Observable<HttpEvent<any>> {
    const token = (sessionStorage.hasOwnProperty('auth') && sessionStorage.getItem('auth')) ?
      sessionStorage.getItem('auth') : null;
    let newHeaders = req.headers;
    if (token) {
      if(req.headers.has('req_type') && req.headers.get('req_type') === 'file') {
        req = req.clone({'responseType': 'blob'});
      } else {
        newHeaders = newHeaders.append('Content-Type', 'application/json');
      }
      newHeaders = newHeaders.append('Authorization', token);
    }
    const authReq = req.clone({headers: newHeaders});
    return next.handle(authReq).pipe(
      map(resp => {
        if (resp instanceof HttpResponse) {
          setTimeout(() => {
            this.jqueryRunner.windowLoadInit(true);
          }, 2000);
          return  resp;
        }
      })
    );
  }
}
